<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="活动标题" prop="title" >
        <a-input v-model="form.title" placeholder="请输入活动标题" />
      </a-form-model-item>
      <a-form-model-item label="活动分类" prop="type" >
        <a-select v-model="form.type">
          <a-select-option v-for="item in typeList" :value="item.id" :key=item.id>{{item.dictLabel}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="是否首页弹框展示" prop="isDisplay" >
        <a-radio-group v-model="form.isDisplay">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="活动名称" prop="activityName" >
        <a-input v-model="form.activityName" placeholder="请输入活动名称" />
      </a-form-model-item>
      <a-form-model-item label="活动内容" prop="content" >
        <a-input v-model="form.content" type="textarea"/>
      </a-form-model-item>
      <a-form-model-item label="赠送现金券数量" prop="voucherGift" >
        <a-input-number :min="0" style="width: 200px" v-model="form.voucherGift" placeholder="请输入赠送现金券数量" />
      </a-form-model-item>
      <a-form-model-item label="背景图" prop="backgroundImage" >
        <file-upload type="image" :defaultList="form.backgroundImageArr" :count="1"
                     @input="getImg($event, 'backgroundImage')"></file-upload>
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getActivity, addActivity, updateActivity } from '@/api/activity/activity'
import Editor from '@/components/Editor'
import {getDicts} from "@/api/system/dict/data";
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      typeList:[],
      // 表单参数
      form: {
        id: null,

        title: null,

        type: null,

        isDisplay: null,

        activityName: null,

        content: null,
        backgroundImage:null,
        backgroundImageArr:[],
        backgroundImageCount:1,

        voucherGift: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: '活动标题不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '活动分类不能为空', trigger: 'change' }
        ],
        isDisplay: [
          { required: true, message: '是否首页弹框展示不能为空', trigger: 'blur' }
        ],
        activityName: [
          { required: true, message: '活动名称不能为空', trigger: 'blur' }
        ],
        backgroundImage: [
          { required: true, message: '背景图不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '活动内容不能为空', trigger: 'blur' }
        ],
        voucherGift: [
          { required: true, message: '赠送现金券数量不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initType()
  },
  activated() {
    this.initType()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    initType(){
      getDicts('activity_type').then(res=>{
        this.typeList = res.data
      })
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        type: null,
        isDisplay: null,
        activityName: null,
        backgroundImage:null,
        backgroundImageArr:[],
        backgroundImageCount:1,
        content: null,
        voucherGift: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.open = true
      this.reset()
      this.formType = 1
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.open = true
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getActivity({"id":id}).then(response => {
        this.form = response.data
        this.formTitle = '修改'
        let that = this;
        this.form.backgroundImageArr = []
        this.form.backgroundImageArr.push({
          uid: guid(8, 10),
          name: that.form.backgroundImage,
          status: 'done',
          halfUrl: that.form.backgroundImage,
          url: that.form.backgroundImage,
          path: that.form.backgroundImage
        })
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateActivity(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addActivity(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
